
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import { clearLocalStoragePreservingUserPreferences } from "../../utilis/preservedLocalStorage";
import "./Logout.css";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const logoutUser = async () => {
      try {
        clearLocalStoragePreservingUserPreferences();

        navigate("/");

      } catch (error) {
        console.error("Erro ao deslogar:", error?.message);
        navigate("/");
      }
    };

    setTimeout(() => {
      logoutUser();
    }, 1000);

  }, [navigate]);

  return (
    <Container
      fluid
      className="d-flex justify-content-center align-items-center vh-100"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${'./images/capa.png'})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <Container
        className="logout-card p-4 border rounded-lg shadow"
        style={{
          maxWidth: '450px',
          backgroundColor: 'rgba(255, 255, 255, 0.65)',
          backdropFilter: 'blur(12px)',
          borderRadius: '16px',
          border: '1px solid rgba(255, 255, 255, 0.18)',
          boxShadow: '0 8px 32px 0 rgba(28, 66, 32, 0.37)',
          transition: 'all 0.3s ease'
        }}
      >
        <h2 className="fw-bold" style={{ color: '#1c4220', marginBottom: 8 }}>SGU MOTOMCO</h2>
        <h1 className="logout-title">Saindo...</h1>
        <p className="logout-text">
          Você está sendo desconectado com segurança.<br />Até logo!
        </p>
        <div className="logout-loader"></div>
      </Container>
    </Container>
  );
};

export default Logout;
